import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const groupStyles = {
  header: "flex justify-between items-start pt-[0.8rem] mb-[0.4rem] w-full",
  title: "flex-1 overflow-auto max-h-[9rem]",
  content: "flex flex-col bg-neutral-50 gap-2 p-[1.6rem] w-full rounded",
  dragHandle:
    "flex min-h-full w-fit items-center justify-center px-[1.05rem] rounded-l hover:bg-black/5",
  groupActions: "flex items-center justify-end gap-small w-[12rem]",
  shrinkShade: "absolute bottom-0 left-0 right-0 h-60 z-10 bg-shrinkShade",
  repeatButton:
    "absolute bottom-[-4.5rem] max-w-[100%] flex items-center pl-[1.6rem] pr-[0.5rem] py-[0.3rem] rounded cursor-not-allowed text-neutral-400 bg-white border-solid border border-neutral-400",
};

export const getGroupCardClassNames = ({ current }: { current?: boolean }) => {
  const baseStyles =
    "border-2 border-neutral-20 bg-neutral-20 flex max-w-[92.6rem] m-auto p-[0.4rem] pr-[3.2rem] rounded gap-small transition-colors duration-300";
  const currentStyles = "border-cyan-240 shadow-modal";

  return twMerge(clsx(baseStyles, current && currentStyles));
};

export const getGroupFieldListClassNames = ({
  shrinking,
}: {
  shrinking?: boolean;
}) => {
  const baseStyles = "relative overflow-visible";
  const shrinkingStyles = "max-h-[36rem] overflow-hidden";

  return clsx(baseStyles, shrinking && shrinkingStyles);
};

export const getGroupFieldContainerClassNames = ({
  shrinking,
  index,
}: {
  shrinking?: boolean;
  index: number;
}) => {
  const baseStyles =
    "relative transition-[margin-top] duration-200 ease-linear mt-0 z-[unset]";
  const marginStyles = index ? "mt-[-12rem]" : "mt-[-5rem]";
  const zIndexStyles = ["z-[5]", "z-[4]", "z-[3]", "z-[2]", "z-1", "z-0"];

  return clsx(
    baseStyles,
    shrinking && marginStyles,
    shrinking && zIndexStyles[index],
  );
};
